import {getDictItemsByCode} from '/@/utils/dict/index';
import { PrjInitTypeEnum } from "/@/enums/configEnum";
import { filterDicByTenantStatus } from "/@/utils/auth";
import { getDynamicStatus } from "/@/utils/commonFunc";
import { getIconByStatus } from "/@/utils/status";

export const projectApprovalStatusList = ['in_approval', 'un_confirm', 'del_in_approval', 'edit_in_approval'];

function getDictValue(arr, key) {
  if (Array.isArray(arr)) {
    let it = arr.find(item => {
      return item.value == key
    })
    return it?.label
  } else {
    return ''
  }
}

// function getDictDescription(arr, key) {
//   if (Array.isArray(arr)) {
//     let it = arr.find(item => {
//       return item.value == key
//     })
//     return it?.description
//   } else {
//     return ''
//   }
// }

export const getProjectStatus = (option) => {
  let items = getDictItemsByCode('project_status')
  let text = getDictValue(items, option)
  return text
}

export const getSettlement = (option) => {
  let items = getDictItemsByCode('settlement')
  let text = getDictValue(items, option)
  return text
}


export const getProjectType = (prjType) => {
  const prjTypeArr = prjType?.split(',') || []
  let text = ''
  const prjTypeObjData = getPrjTypeOptionData(2,prjTypeArr)
  if (prjTypeObjData.length) {
    prjTypeObjData.forEach((options) => {
      if (options.children && options.children.length) {
        options.children.forEach(item => {
          if (prjTypeArr.includes(item.value)) {
            text += item.labelAll + ','
          }
        })
      }
    })
  }
  if (text) {
    text = text.slice(0, text.length - 1)
  }
  return text
}

export const csoHideType =  ["st_tr_rwr","st_tr_cc","st_tr_pr","st_tr_qpf"]
//type 1: 新建  2: 编辑
export const getPrjTypeOptionData = (type, prjSelectTypeArr) => {
  const prjTypeOptions: any = [];
  let firstPrjData = getDictItemsByCode('prj_classify')
  const excludeArr = type == 2 ? prjTypeHasExclude(prjSelectTypeArr) : [];
  firstPrjData.forEach((item) => {
    const itemDic = getDictItemsByCode(item.description)
    let childrenData = filterDicByTenantStatus(itemDic, excludeArr)
    let tempData: any = []
    childrenData.forEach((itemChild) => {
      const childDataTemp = {
        label: itemChild.label,
        value: itemChild.value,
        key: itemChild.value,
        labelAll: item.label + '-' + itemChild.label,
        disabled: false,
      }
      tempData.push(childDataTemp)
    })
    prjTypeOptions.push({
      value: item.value,
      key: item.value,
      label: item.label,
      labelAll: item.label,
      checkable: false,
      children: tempData
    })
  })
  return prjTypeOptions
}

export function prjTypeHasExclude(selectTypeArr) {
  return selectTypeArr?.filter(item => csoHideType.includes(item)) ?? []
}

export const getSubjectType = (option) => {
  let items = getDictItemsByCode('subject_area')
  let text = ''
  if (option) {
    let valueArr = option.split(',')
    items.forEach(item => {
      if (valueArr.includes(item.value)) {
        text += item.title + ','
      }
    })
    if (text) {
      text = text.slice(0, text.length - 1)
    }
  }
  return text
}

export const formatYuan = (num) => {
  if (num === undefined || num === null || num === '') {
    return '-'
  }
  const numStr = num.toString().split('.');
  let numInt = numStr[0];
  let numDec = numStr.length > 1 ? '.' + numStr[1] : '.';
  while (3 - numDec.length > 0) numDec += '0';
  let resultInt = '';
  while (numInt.length > 3) {
    resultInt = ',' + numInt.slice(-3) + resultInt;
    numInt = numInt.slice(0, -3);
  }
  return numInt + resultInt + numDec;
}

export const formatFileSize = (bytes, decimalPoint = 2) => {
  if (bytes == undefined || bytes == null || bytes === '') {
    return '-'
  }
  bytes = parseFloat(bytes)
  if (bytes == 0) return "0 Bytes";
  if (bytes < 1) return bytes + " Bytes";
  let k = 1024,
    sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
    i = Math.floor(Math.log(bytes) / Math.log(k));
  return (
    parseFloat((bytes / Math.pow(k, i)).toFixed(decimalPoint)) + " " + sizes[i]
  );
}

// 解决toFixed精度失准问题
export const handleTofixedPrecision = () => {
  Number.prototype.toFixed = function (n) {
    if ( n < 0) {
      n = 0
    }
    if (n > 20 ) {
      n = 20;
      // throw new RangeError('toFixed() digits argument must be between 0 and 20');
    }
    const number = this;
    if (isNaN(number) || number >= Math.pow(10, 21)) {
      return number.toString();
    }
    if (typeof (n) == 'undefined' || n == 0) {
      return (Math.round(number)).toString();
    }
    let result = number.toString();
    const arr = result.split('.');
    // 整数的情况
    if (arr.length < 2) {
      result += '.';
      for (let i = 0; i < n; i += 1) {
        result += '0';
      }
      return result;
    }
    const integer = arr[0];
    const decimal = arr[1];
    if (decimal.length == n) {
      return result;
    }
    if (decimal.length < n) {
      for (let i = 0; i < n - decimal.length; i += 1) {
        result += '0';
      }
      return result;
    }
    result = integer + '.' + decimal.substr(0, n);
    const last = decimal.substr(n, 1);
    // 四舍五入，转换为整数再处理，避免浮点数精度的损失
    if (parseInt(last, 10) >= 5) {
      const x = Math.pow(10, n);
      result = (Math.round((parseFloat(result) * x)) + 1) / x;
      result = result.toFixed(n);
    }
    return result;
  }
};

// 翻译交付物类型的单价
export const formatUnit = (deliveryType) => {
  // 获取结算单单位字典
  let deliveryUnit = getDictItemsByCode('delivery_unit');
  let unit = '';
  if (deliveryUnit) {
    deliveryUnit.forEach(item => {
      if (item.value === deliveryType) {
        unit = item.label;
      }
    })
  }
  return unit;
}
export const formatPopModeLabel = (popType, taskType) => {
  let popIpModeList = getDictItemsByCode('pop_mode') || [];
  let popVpModeList = getDictItemsByCode('pop_vp_mode') || [];
  let meetingTypeList = getDictItemsByCode('meeting_type') || [];
  let ipPopPublicModeList = getDictItemsByCode('pop_ip_public_mode') || [];
  let vpPopPublicModeList = getDictItemsByCode('pop_vp_public_mode') || [];
  let deliveryTypeDict = {
    'pop_ip': popIpModeList,
    'pop_vp': popVpModeList,
    'online_meeting': meetingTypeList,
    'pop_public_ip': ipPopPublicModeList,
    'pop_public_vp': vpPopPublicModeList,
  };
  let dict = deliveryTypeDict[taskType];
  let label = '';
  if (dict) {
    label = dict.find(i => i.value === popType)?.text || '';
  }
  return label;
}
// 翻译交付物类型label
export const formatStatementsDeliveryLabel = (deliveryType) => {
  let deliveryTypeList = getDictItemsByCode('statement_delivery_type');
  // console.log(deliveryType,deliveryTypeList);
  let label = '';
  if (deliveryType === 'total') {
    label = '总计';
  } else {
    if (deliveryTypeList) {
      deliveryTypeList.forEach(item => {
        if (item.value === deliveryType) {
          label = item.label;
        }
      })
    }
  }
  return label;
}

export const formatPrice = (num) => {
  if (num == null) {
    return ''
  }
  let str = num.toString();
  // 没有小数点时，在末尾补上.00
  if (str.indexOf('.') === -1) {
    str += '.00';
  } else {
    if (str.split(".")[1].length === 1) {
      str += '0';
    }
  }
  return str.replace(/(\d)(?=(\d{3})+\.)/g, '$1,').replace(/\.$/, '')
}

export const formatMoney = (num) => {
  if (!num) {
    num = 0;
  }
  let str = num.toString();
  // 没有小数点时，在末尾补上.00
  if (str.indexOf('.') === -1) {
    str += '.00';
  } else {
    if (str.split(".")[1].length === 1) {
      str += '0';
    }
  }
  return str.replace(/(\d)(?=(\d{3})+\.)/g, '$1,').replace(/\.$/, '')
}

export const formatUnitPrice = (num) => {
  if (num == null) {
    return ''
  }
  const str = num.toString();
  return str.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}
export function formatPriceManagementMoney(num) {
  if (num == null) {
    return '';
  }

  return formatMoney(num);
}
// 获取交付物类型父级类型
export const getDeliveryParentType = (deliveryType) => {
  if (deliveryType === 'annotation') {
    return 'annotation';
  }
  let deliveryTypeList = getDictItemsByCode('statement_delivery_type');
  // console.log(deliveryType, deliveryTypeList);
  return deliveryTypeList.find(item => item.value === deliveryType)?.itemType;
}

// 获取任务类型父级类型
export const getTaskTypeParentType = (taskType) => {
  if (taskType === 'data_annotation') {
    return 'annotation';
  }
  let taskTypeList = getDictItemsByCode('task_type');
  return taskTypeList.find(item => item.value === taskType)?.itemType;
}

export const isAnnotationTaskOrDelivery = (record) => {
  if (!record) {
    return false;
  }
  const isValue = typeof record === 'string';
  const taskType = isValue ? record : record.taskType;
  const deliveryType = isValue ? record : (record.type ?? record.deliveryType ?? record.serviceDeliveryType);
  const taskParentType = isValue ? getTaskTypeParentType(taskType) : (record.taskTypeBelong ?? record.taskTypeParentType ?? getTaskTypeParentType(taskType));
  const deliveryParentType = isValue ? getDeliveryParentType(deliveryType) : (record.deliveryTypeBelong ?? record.deliveryTypeParentType ?? getDeliveryParentType(deliveryType));
  return taskType === 'data_annotation' || deliveryType === 'annotation' || taskParentType === 'annotation' || deliveryParentType === 'annotation';
}

// 获取结算单状态父级类型
export const getStatementStatusParent = (statementStatus) => {
  let statementStatusList = getDictItemsByCode('statement_status');
  return statementStatusList.find(item => item.value === statementStatus)?.itemType;
}

export const getLabelByMultipleDict = (value, dictKeys=[]) => {
  let label='';
  if(Array.isArray(dictKeys)) {
    for (let i = 0; i < dictKeys.length; i++) {
      let dictList = getDictItemsByCode(dictKeys[i]);
      label = dictList?.find(item => item.value === value)?.label
      if(label){
        break;
      }
    }
  }
  return label||'-';
}

/*
* 获取字典项item
* @params value可传任意key获取item
* @params key默认传value
* */
export const getDictItem = (value, dict, key='value') => {
  let dictList = getDictItemsByCode(dict);
  return dictList?.find(item => item[key] === value);
}

// 通过字典翻译
export const getDictLabel = (value, dict) => {
  return getDictItem(value,dict)?.label || '-';
}
//通过label查找key
export const getDictKeyByLabel = (label, dict) => {
  let dictList = getDictItemsByCode(dict);
  return dictList?.find(item => item.label === label)?.value;
}

// 获取字典值父级类型
export const getDictValueParent = (value,dict) => {
  let dictList = getDictItemsByCode(dict);
  return dictList.find(item => item.value === value)?.value;
}

export const getPrjFieldsShowByType = (type) => {
  return type !== PrjInitTypeEnum.SELF_PRJ_INIT
}

/*
* @params type 接口项目类型
* @params utils 工具类判断是否是自建项目、所在方
* return string 判断所在方项目类型
* */
export const getPrjTypeParamsKey = (type, utils) => {
  if(!utils?.isSelfProject) {
    type = utils?.belongUnit === 'initiator' ? 'entrust_prj_init' : 'info_prj_init';//默认承接项目 receiver
  }
  return type;
}

/*
* @params record 列表数据
* @params type 处理图标
* return string 状态label
* */
export const handleStatusFormat = (record, type='') => {
  let statusData = getDynamicStatus(record.projectInfoBaseVO,record)
  if(type === 'icon'){
    return getIconByStatus(statusData?.status)
  }
  return getDictLabel(statusData.status,'project_status')
}
